import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

import Input from "~/components/Form/LandingInput"
import Tooltip from "~/components/Tooltip"
import Spacer from "~/components/Spacer"
import FormError from "~/components/Form/ErrorText"
import withTranslations from "~/components/_hocs/withTranslations"

import DropdownMenu from "../DropdownMenu"
import InputTitle from "./InputTitle"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$compact ? "10px" : "0")};
`

@inject((all) => ({
  validateDisplayMessage: all.store.trafficLookup.validateDisplayMessage,
  licenseIDNumber: all.store.trafficLookup.licenseID,
  changeLicenseIDNumber: all.store.trafficLookup.changeLicenseIDNumber,
  fetcherName: all.store.trafficLookup.fetcherName,
}))
@observer
class LicenseInput extends Component {
  handleChange = (e) => {
    this.props.changeLicenseIDNumber(e.target.value)
  }

  render() {
    let licenseInput = ""
    const licenseErrorHandler = this.props.validateDisplayMessage("licenseID")
    if (this.props.fetcherName === "NY") {
      licenseInput = (
        <Input
          placeholder={this.props.translate("nyPlaceholder")}
          onChange={this.handleChange}
          value={this.props.licenseIDNumber}
          error={licenseErrorHandler}
          maxLength={9}
          type="tel"
        />
      )
    } else {
      licenseInput = (
        <Input
          placeholder={this.props.translate("placeholder")}
          onChange={this.handleChange}
          value={this.props.licenseIDNumber}
          error={licenseErrorHandler}
          minLength={3}
          maxLength={20}
        />
      )
    }

    const compact = this.props.simple
    return (
      <Wrap $compact={compact}>
        <InputTitle>
          {this.props.translate("label")}
          {!compact && this.props.fetcherName === "NY" && (
            <Tooltip
              size={21}
              message={this.props.translate("tooltip")}
              icon="question"
            />
          )}
          {!compact && (
            <>
              <Spacer direction="width" mobile={11} desktop={11} />
              <DropdownMenu columnNumber="one" />
            </>
          )}
        </InputTitle>
        {!compact && <Spacer desktop={16} mobile={4} />}
        {licenseInput}
        <FormError error={licenseErrorHandler} />
      </Wrap>
    )
  }
}

export default withTranslations(LicenseInput, "form.traffic.license")
